import { render } from "./Onboarding3.vue?vue&type=template&id=c0ab2be6&scoped=true"
import script from "./Onboarding3.vue?vue&type=script&lang=js"
export * from "./Onboarding3.vue?vue&type=script&lang=js"

import "./Onboarding3.vue?vue&type=style&index=0&id=c0ab2be6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c0ab2be6"

export default script